<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/casa-ferreirinha')">Casa Ferreirinha
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/portugal/douro-valley/howards-folly')">Howard’s Folly
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/prats-and-symington')">Prats and
                        Symington (Chryseia)
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-crasto')">Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vale-meao')">Quinta Do Vale
                        Meao
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vallado')">Quinta Do Vallado
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/quinta-do-vesuvio')">Quinta Do Vesuvio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/portugal/douro-valley/roquette-cazes-quinta')">Roquette
                        &amp; Cazes — Quinta do Crasto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/portugal/douro-valley/symington')">Symington
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/portugal/douro-valley')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Howard’s Folly</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Cosa ottieni quando incroci uno Yorkshireman senza fronzoli che vive a Hong Kong con un ambizioso,
                        Aussie con sede in Portogallo? Anche se potrebbero venire in mente molte cose, scommettiamo che una classe mondiale,
                        un buon vino appetitoso e acclamato non è la prima risposta. Eppure dovrebbe esserlo; IL
                        nato da un'idea di Howard Bilton e dell'enologo David Baverstock, Howard's Folly sicuramente non lo è
                        folle.
                    </div>

                    <div class="howto-title2">Un australiano in Alentejo</div>
                    <div class="howto-text">
                        In effetti, questo è abbastanza facile: nel 2002, Howard, un amante di tutti i vini pregiati ma in particolare del
                        Il portoghese ha collaborato con David Baverstock (dell'azienda vinicola portoghese Esporão) con la visione comune di
                        creando vini superbamente fruttati e corposi (sia rossi che bianchi) dalla regione dell'Alentejo
                        nord del Portogallo. David, l'unico non portoghese ad aver mai vinto “Portuguese Winemaker of the
                        Year” all'International Wine Challenge ha portato con sé oltre 20 anni di esperienza
                        Howard's Folly, dopo aver lavorato prima con Port (sia a Croft che a Symington), poi con i vini da tavola
                        (in particolare a Quita do Castro). Ciò che è iniziato letteralmente come una follia, è diventato immenso
                        proporzioni, tanto che dopo anni trascorsi senza locali il duo ne ha aperto uno proprio
                        cantina nel 2018.
                    </div>

                    <div class="howto-title2">Il portoghese Che Guevara</div>
                    <div class="howto-text">
                        Nonostante Howard's Folly abbia un "minuscolo" vigneto di 6,5 ettari per la produzione di Sonhador e vini rossi di riserva, David acquista uve da agricoltori locali con piccoli appezzamenti di viti molto vecchie (tra cui Alicante Bouschet, Syrah, Touriga Nacional) per dare ai suoi vini la complessità e le spezie che gli hanno fatto guadagnare il titolo di uomo responsabile della rivoluzione del commercio del vino da tavola del Portogallo. "Riteniamo che la somma delle parti sia più interessante delle singole varietà prese singolarmente", afferma David, "molto entusiasta di lavorare con la vecchia vite Portalegre dove abbiamo piantagioni miste di circa 20 varietà di uva di cui non conosciamo nemmeno l'intera gamma". ¡Hasta la rivoluzione sempre!
                    </div>

                    <div class="howto-title2">Molto potenziale portoghese</div>
                    <div class="howto-text">
                        Con il clima caldo e secco dell'Alentejo, la regione ha attirato investimenti negli ultimi anni, con
                        molti talentuosi viticoltori aprono bottega. Oggi circa il 45% di tutto il vino bevuto in Portogallo lo è
                        prodotto nell'Alentejo, e questo sembra destinato a crescere; forse per la qualità superlativa
                        della miscelazione, forse l'enorme potenziale o forse perché il prezzo per una multa di alta qualità
                        il vino rimane molto conveniente.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Howard’s Folly</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Was bekommt man, wenn man einen geradlinigen Yorkshire-Mann, der in Hongkong lebt, mit einem ehrgeizigen,
                        Ein in Portugal ansässiger Australier? Auch wenn einem viele Dinge in den Sinn kommen, wetten wir auf ein erstklassiges,
                        Ein köstlicher, hochgelobter erlesener Wein ist nicht die erste Antwort. Und doch sollte es so sein; Die
                        Howard’s Folly ist eine Idee von Howard Bilton und dem Winzer David Baverstock
                        töricht.
                    </div>

                    <div class="howto-title2">Ein Australier im Alentejo</div>
                    <div class="howto-text">
                        Tatsächlich ist das ganz einfach: Im Jahr 2002 gründete Howard, ein Liebhaber aller erlesenen Weine, vor allem aber der
                        Die Portugiesen haben sich mit David Baverstock (vom portugiesischen Weingut Esporão) zusammengetan, mit der gemeinsamen Vision von
                        Herstellung herrlich fruchtiger, vollmundiger Weine (sowohl Rot- als auch Weißweine) aus der Region Alentejo
                        Nordportugal. David, der einzige Nicht-Portugiese, der jemals den Titel „Portugiesischer Winzer des Jahres“ gewonnen hat
                        Year“ bei der International Wine Challange brachte über 20 Jahre Erfahrung mit
                        Howard’s Folly, nachdem er zunächst mit Portwein (sowohl bei Croft als auch bei Symington) und dann mit Tafelweinen gearbeitet hatte
                        (insbesondere in Quita do Castro). Was im wahrsten Sinne des Wortes eine Torheit war, wuchs zu einer gewaltigen Größe
                        Proportionen, so sehr, dass das Duo nach Jahren ohne Räumlichkeiten ein eigenes eröffnete
                        Weingut im Jahr 2018.
                    </div>

                    <div class="howto-title2">Der Portugiese Che Guevara</div>
                    <div class="howto-text">
                        Obwohl Howard’s Folly über einen „winzigen“ 6,5 Hektar großen Weinberg für die Produktion von Sonhador- und Reserve-Rotweinen verfügt, bezieht David Trauben von örtlichen Bauern mit kleinen Parzellen mit sehr alten Reben (darunter Alicante Bouschet, Syrah, Touriga Nacional), um seinen Weinen die Komplexität und Würze zu verleihen, die ihm den Titel des Mannes eingebracht haben, der für die Revolutionierung des Tafelweinhandels in Portugal verantwortlich ist. „Wir glauben, dass die Summe der Teile interessanter ist als die einzelnen Sorten für sich“, sagt David, „wir freuen uns sehr, mit alten Portalegre-Reben zu arbeiten, wo wir Mischanpflanzungen von etwa 20 Rebsorten haben, von denen wir nicht einmal das gesamte Spektrum kennen.“ ¡Hasta la revolución siempre!
                    </div>

                    <div class="howto-title2">Viel portugiesisches Potenzial</div>
                    <div class="howto-text">
                        Aufgrund des warmen, trockenen Klimas des Alentejo hat die Region in den letzten Jahren Investitionen angezogen
                        Viele talentierte Winzer eröffnen ihr Geschäft. Heute werden etwa 45 % aller in Portugal getrunkenen Weine getrunken
                        im Alentejo hergestellt, und es sieht so aus, als ob dieser Trend steigen wird; vielleicht wegen der überragenden Qualität
                        der Mischung, vielleicht das große Potenzial oder vielleicht auch wegen des Preises für eine hochwertige Feinkost
                        Wein bleibt sehr erschwinglich.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Howard’s Folly</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Qu'obtenez-vous lorsque vous croisez un Yorkshireman sans fioritures vivant à Hong Kong avec un ambitieux,
                        Australien basé au Portugal ? Bien que beaucoup de choses puissent venir à l'esprit, nous parions qu'une classe mondiale,
                        un bon vin appétissant et très acclamé n'est pas la première réponse. Et pourtant, cela devrait être le cas; le
                        idée originale de Howard Bilton et du vigneron David Baverstock, Howard's Folly n'est certainement pas
                        idiot.
                    </div>

                    <div class="howto-title2">Un Australien en Alentejo</div>
                    <div class="howto-text">
                        En fait, c'est assez facile : en 2002, Howard, un amoureux de tous les grands vins mais particulièrement des
                        Le portugais s'est associé à David Baverstock (de la cave portugaise Esporão) avec la vision commune de
                        créant des vins superbement fruités et corsés (rouges et blancs) de la région de l'Alentejo
                        nord du Portugal. David, le seul non-portugais à avoir jamais remporté le prix du « Vigneron portugais du
                        Année" à l'International Wine Challenge a apporté plus de 20 ans d'expérience avec lui pour
                        Howard's Folly, après avoir travaillé d'abord avec le porto (à la fois chez Croft et Symington), puis les vins de table
                        (notamment à Quita do Castro). Ce qui a commencé littéralement comme une folie est devenu immense
                        proportions, à tel point qu'après avoir passé des années sans locaux, le duo a ouvert le sien
                        cave en 2018.
                    </div>

                    <div class="howto-title2">Le Che Guevara portugais</div>
                    <div class="howto-text">
                        Bien que Howard's Folly ait un "petit" vignoble de 6,5 hectares pour la production de Sonhador et de vins rouges de réserve, David s'approvisionne en raisins auprès d'agriculteurs locaux avec de petites parcelles de très vieilles vignes (dont Alicante Bouschet, Syrah, Touriga Nacional) pour donner à ses vins la complexité et l'épice qui lui ont valu le titre d'homme responsable de la révolution du commerce des vins de table au Portugal. "Nous pensons que la somme des parties est plus intéressante que les variétés individuelles", déclare David, "très excité de travailler avec de vieilles vignes Portalegre où nous avons des plantations mixtes d'environ 20 cépages dont nous ne connaissons même pas la gamme complète". ¡Hasta la révolution siempre !
                    </div>

                    <div class="howto-title2">Beaucoup de potentiel portugais</div>
                    <div class="howto-text">
                        Avec le climat chaud et sec de l'Alentejo, la région a attiré des investissements ces dernières années, avec
                        de nombreux vignerons talentueux s'installent. Aujourd'hui, environ 45% de tout le vin bu au Portugal est
                        produit dans l'Alentejo, et cela devrait augmenter; peut-être à cause de la qualité superlative
                        du mélange, peut-être l'énorme potentiel ou peut-être parce que le prix d'une amende de haute qualité
                        le vin reste très abordable.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Howard’s Folly</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        What do you get when you cross a no-nonsense Yorkshireman living in Hong Kong with an ambitious,
                        Portugal based Aussie? Although many things might spring to mind, we bet a world-class,
                        mouth-watering, highly acclaimed fine wine isn’t the first answer. And yet it should be; the
                        brainchild of Howard Bilton and winemaker David Baverstock, Howard’s Folly sure ain&#39;t
                        foolish.
                    </div>

                    <div class="howto-title2">An Australian in Alentejo</div>
                    <div class="howto-text">
                        In fact, this is quite an easy one: in 2002, Howard, a lover all fine wines but particularly the
                        Portuguese teamed with David Baverstock (of Portugal’s Esporão winery) with the joint vision of
                        creating superbly fruity, full-bodied wines (both red and white) from the Alentejo region of
                        northern Portugal. David, the only non-Portuguese to ever have won “Portuguese Winemaker of the
                        Year” at the International Wine Challange brought over 20 years of experience with him to
                        Howard’s Folly, after working first with Port (at both Croft and Symington), then table wines
                        (notably at Quita do Castro). What started off as literally a folly, grew to immense
                        proportions, so much so that after spending years without premises the duo opened their own
                        winery in 2018.
                    </div>

                    <div class="howto-title2">The Portuguese Che Guevara</div>
                    <div class="howto-text">
                        Despite Howard’s Folly having a “tiny” 6.5 hectare vineyard for the production of Sonhador and reserve red wines, David sources grapes from local farmers with small plots of very old vines (including Alicante Bouschet, Syrah, Touriga Nacional) to give his wines the complex and spice that have earned him the title of the man responsible for revolutionising Portgual’s table wine trade. “We believe the sum of the parts is more interesting than the individual varieties on their own”, says David, “very excited to be working with old vine Portalegre fruit where we have mixed plantings of around 20 grape varietals where we don’t even know the full range.” ¡Hasta la revolución siempre!
                    </div>

                    <div class="howto-title2">Lots of Portuguese potential</div>
                    <div class="howto-text">
                        With Alentejo’s warm, dry climate, the region has attracted investment in recent years, with
                        many talented winemakers setting up shop. Today about 45% of all wine drunk in Portugal is
                        produced in the Alentejo, and this looks set to rise; perhaps because of the superlative quality
                        of the blending, perhaps the huge potential or perhaps because the price for a high-quality fine
                        wine remains very affordable.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HowardsFolly",
    data() {
        return {
            select: {report: 'Howard’s Folly', src: '/wine-guide/portugal/douro-valley/howards-folly'},
            items: [
                {report: 'Casa Ferreirinha', src: '/wine-guide/portugal/douro-valley/casa-ferreirinha'},
                {report: 'Howard’s Folly', src: '/wine-guide/portugal/douro-valley/howards-folly'},
                {report: 'Prats and Symington (Chryseia)', src: '/wine-guide/portugal/douro-valley/prats-and-symington'},
                {report: 'Quinta do Crasto', src: '/wine-guide/portugal/douro-valley/quinta-do-crasto'},
                {report: 'Quinta Do Vale Meao', src: '/wine-guide/portugal/douro-valley/quinta-do-vale-meao'},
                {report: 'Quinta Do Vallado', src: '/wine-guide/portugal/douro-valley/quinta-do-vallado'},
                {report: 'Quinta Do Vesuvio', src: '/wine-guide/portugal/douro-valley/quinta-do-vesuvio'},
                {report: 'Roquette & Cazes — Quinta do Crasto', src: '/wine-guide/portugal/douro-valley/roquette-cazes-quinta'},
                {report: 'Symington', src: '/wine-guide/portugal/douro-valley/symington'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Howard’s Folly | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the unique and exceptional wines of Howard\'s Folly, a renowned wine producer in the Douro Valley region. Experience the intricate blend of traditional winemaking methods and modern techniques in each bottle. Explore the world of Howard\'s Folly and indulge in the essence of Douro Valley.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
